export function validarTelefone(telefone) {
    if (!telefone) {
        return true;
    }

    // Remove caracteres não numéricos
    telefone = String(telefone).replace(/\D/g, '');

    // Verifica quantidade de dígitos (10 para fixo, 11 para celular)
    if (telefone.length < 10 || telefone.length > 11) {
        return false;
    }

    // Rejeita números com todos os dígitos iguais (ex: 11111111111)
    const primeiroDigito = telefone.charAt(0);
    const todosIguais = telefone.split('').every(digito => digito === primeiroDigito);
    if (todosIguais) {
        return false;
    }

    // Se tem 11 dígitos, o 3º dígito deve ser 9 (celular)
    if (telefone.length === 11 && telefone.charAt(2) !== '9') {
        return false;
    }

    // Lista de DDDs válidos do Brasil
    const dddsValidos = [
        11, 12, 13, 14, 15, 16, 17, 18, 19, // São Paulo
        21, 22, 24,                          // Rio de Janeiro
        27, 28,                              // Espírito Santo
        31, 32, 33, 34, 35, 37, 38,          // Minas Gerais
        41, 42, 43, 44, 45, 46,              // Paraná
        47, 48, 49,                          // Santa Catarina
        51, 53, 54, 55,                      // Rio Grande do Sul
        61,                                  // Distrito Federal
        62, 64,                              // Goiás
        63,                                  // Tocantins
        65, 66,                              // Mato Grosso
        67,                                  // Mato Grosso do Sul
        68,                                  // Acre
        69,                                  // Rondônia
        71, 73, 74, 75, 77, 79,              // Bahia
        81, 82, 83, 84, 85, 86, 87, 88, 89,  // Nordeste
        91, 92, 93, 94, 95, 96, 97, 98, 99   // Norte
    ];

    const ddd = parseInt(telefone.substring(0, 2), 10);
    if (!dddsValidos.includes(ddd)) {
        return false;
    }

    // Para telefone fixo (10 dígitos), o 3º dígito deve ser 2, 3, 4 ou 5
    if (telefone.length === 10) {
        const terceiroDigito = parseInt(telefone.charAt(2), 10);
        if (![2, 3, 4, 5].includes(terceiroDigito)) {
            return false;
        }
    }

    return true;
}
